import { render } from "./Horarios.vue?vue&type=template&id=545b759a&scoped=true"
import script from "./Horarios.vue?vue&type=script&lang=js"
export * from "./Horarios.vue?vue&type=script&lang=js"

import "./Horarios.vue?vue&type=style&index=0&id=545b759a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545b759a"]])

export default __exports__